var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!../../node_modules/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./twitchForm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21c6d168\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!../../node_modules/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./twitchForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/twitchForm.vue
// module id = 219
// module chunks = 1